
import { defineComponent, onMounted, useStore } from '@nuxtjs/composition-api'
import { recommendationTemplateType } from '@/store/recommendations'
import { setupGtmRecommendationStart } from '@/assets/composition/setup-gtm'

export default defineComponent({
  props: {
    page: { type: Object, required: true },
  },
  setup() {
    const store = useStore()

    const gtmRecommendationStart = setupGtmRecommendationStart()

    function startQuestionnaire() {
      store.commit('recommendations/initSelectionPath')
      store.commit('recommendations/setSelection')
      store.commit('recommendations/setActiveTemplate', recommendationTemplateType.QUESTIONNAIRE)
      gtmRecommendationStart()
    }

    onMounted(async () => {
      try {
        await store.dispatch('recommendations/loadRecommendationData')
      } catch (error) {
        console.error('Failed to load recommendation data:', error)
      }
    })

    return {
      startQuestionnaire,
    }
  },
})
